import styled from 'styled-components';

export const ContentSection = styled.div<{ horizontal?: boolean; width?: string; height?: string }>`
  position: relative;
  display: flex;
  flex-direction: ${({ horizontal }) => (horizontal ? 'row' : 'column')};
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  padding: 12px 20px;
  border-bottom: 1px solid #ffffff1f;
`;

ContentSection.defaultProps = {
  horizontal: false,
  width: '100%',
};
